import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=1f32386c&scoped=true&"
import script from "./dialogComponent.vue?vue&type=script&lang=js&"
export * from "./dialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=1f32386c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32386c",
  null
  
)

export default component.exports